
<template>
  <div>
    <v-row v-if="one_item.answer && already_signed" justify="center">
      <!-- {{setResume().map(r=> `${r.title}-${r.answer}`).join('##') == one_item.answer}} -->
      <v-alert type="error" v-if="setResume().map(r=> `${r.title}--${r.answer}`).join('##') != one_item.answer" :value="true">
        <div>
          O conteúdo assinado (as respostas até este momento) está diferente (alguma resposta foi alterada)
        </div>
        <div class="text-right mx-3 mt-5">
          <v-dialog
            scrollable 
            max-width="500px"
            transition="dialog-transition"
          >
            <template v-slot:activator="{on}">
              <v-btn small rounded v-on="on" class="error--text">ver diferença</v-btn>
            </template>
            <v-card style="border-radius:12px">
              <v-card-title primary-title>
                <div class="title mb-0">Diferenças</div>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="mb-3">
                <v-row class="px-3">
                  <v-col> <b>Título </b></v-col>
                  <v-col> <b>Resp. Assinada </b></v-col>
                  <v-col> <b>Nova Resposta </b></v-col>
                </v-row>
                <div v-for="(item,idx) in one_item.answer.split('##')" :key="item.answer"  >
                  <v-row  
                    style="border: solid 1px #eee; border-radius: 5px;"
                    v-if="item.split('--')[1] != oneExecution.done_items[idx].answer"
                    :class="['px-3', item.split('--')[1] != oneExecution.done_items[idx].answer? 'red--text' : '']"
                  >
                    <v-col> <b>{{ item.split('--')[0] }}: </b></v-col>
                    <v-col>{{ item.split('--')[1] == 'null'? '' : item.split('--')[1] }}</v-col>
                    <v-col>{{oneExecution.done_items[idx].answer}}</v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
            
          </v-dialog>

        </div>
        <div>
        </div>
      </v-alert>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'AlertChangeSignature',
  props: {
    one_item: {
      type: Object,
    },
    already_signed: {
      type: Boolean,
      defalt: false,
    }
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    setResume(){
      let one_short = `${this.one_item.kind}-${this.one_item.title}-${this.one_item.sentence}`
      let sig_idx = this.oneExecution.done_items.map(di=> `${di.kind}-${di.title}-${di.sentence}`).indexOf(one_short)
      
      let resume = []
      let one_item = {}
      for (let idx = 0; idx < sig_idx; idx++) {
        const el = this.oneExecution.done_items[idx];
        resume.push(el)
      }

      return resume
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      oneExecution: state => state.Execution.oneExecution,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>